import { ApprovalStatusType } from "../../../../domain/model/approval-status-type";
import { UserInfo } from "../../../../domain/model/user-info";
import { Uuid } from "../../../../domain/model/uuid/uuid.type";
import { DataStoreId } from "../../data-store-id.type";


export class StoreApprovalStatus implements DataStoreId {
  readonly id: string;
  readonly date: Date;
  readonly approvedBy: UserInfo;
  readonly status: ApprovalStatusType;

  constructor(id: Uuid, date: Date, approvedBy: UserInfo, status: ApprovalStatusType) {
    this.id = id.asString();
    this.date = date;
    this.approvedBy = approvedBy;
    this.status = status;
  }
}
